export default class FirstView {
  constructor(config) {
    this.container = config.container
    this.videoClass = config.videoClass || 'firstView_video'
    this.skipBtnClass = config.skipBtnClass || 'firstView_skip-btn'
    this.onChange = config.onChange
    this.scrollLength = 0
    this.beforeTime = 2 // 2秒前に終了する
    this.endFlag = false

    this.videoElm = document.getElementsByClassName(this.videoClass)[0]
    this.skipBtnElm = document.getElementsByClassName(this.skipBtnClass)[0]

    // 初期化処理
    this.playVideo()

    this.skipBtnElm.addEventListener('click', (e) => this.skipAction(e))
  }

  playVideo() {
    this.videoElm.play()
    // this.videoElm.addEventListener('ended', (e) => this.skipAction(e))
    this.videoElm.addEventListener('timeupdate', () => {
      const cur = this.videoElm.currentTime
      const duration = this.videoElm.duration
      if (duration - this.beforeTime <= cur && !this.endFlag) this.skipAction()
    })
  }

  pauseVideo() {
    this.videoElm.pause()
  }

  resetVideoElm() {
    this.videoElm = document.getElementsByClassName(this.videoClass)[0]
    this.playVideo()
  }

  skipAction(e) {
    if (e) e.preventDefault()
    this.endFlag = true
    if (this.onChange) this.onChange(this.container)
    setTimeout(() => {
      this.videoElm.pause()
    }, this.beforeTime * 1000)
  }
}
